function stringEndsWith(substring, string) {
  return string.indexOf(substring, string.length - substring.length) !== -1;
}

export { stringEndsWith }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./frontend/js/Base/helper.js